// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"EventObject__Wrapper__1Gdx3","Content":"EventObject__Content__2LWH7","HoverInfo":"EventObject__HoverInfo__rLdMG","TooltipText":"EventObject__TooltipText__Bzefl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/EventObject/EventObject.css
// module id = 172
// module chunks = 0